import { QuestionType } from '@app/core/model/enums/question-type.enum'
import { ScopeConfiguration } from '@app/core/model/scope-version'
import { Scenario } from '../model/scenario.model'
import { getConfigurationWithEmptyAnswerValues } from './get-configuation-with-empty-answer-values.util'
import { getSectionNameString, ScopeConfigurationPromptStatus } from './scope-configuration.utils'
import { FormulaService } from '@app/shared/services/formula.service'

export function getConfigurationWithoutAddons(
  scenario: Scenario,
  scopeConfiguration: ScopeConfiguration,
  formulaService: FormulaService
) {
  let configuration = { ...scopeConfiguration }

  scenario.categories.forEach((category) => {
    category.questions.forEach((question) => {
      if (question.type === QuestionType.DELIVERABLE) {
        const isCategoryDisplayed = !category.displayCondition || formulaService.calculate(category.displayCondition)
        const isQuestionDisplayed = !question.displayCondition || formulaService.calculate(question.displayCondition)
        const sectionName = getSectionNameString(question, null)
        const rawValue = question.value?.split(ScopeConfigurationPromptStatus.DELETED)?.[0]

        configuration[category.id] = {
          ...configuration[category.id],
          [question.id]: isCategoryDisplayed && isQuestionDisplayed ? rawValue : sectionName,
        }
      }
    })
    configuration = getConfigurationWithEmptyAnswerValues(category, configuration)
  })

  return configuration
}
